import { Auth } from '@modules/auth/model';
import { OAuthService } from '@core/oauth/service';
import { OAuth } from '@core/oauth/model';
import { HttpService } from '@core/http';
import { Effect, pipe } from 'effect';

export namespace AuthService {
  export function exchangeToken(token: Auth.Token): OAuth.HttpEffect {
    return pipe(
      HttpService.post<OAuth.Tokens, OAuth.Error>('/app/authenticate/as/exchange', {
        access_token: token,
      }),
      Effect.tap(OAuthService.saveOAuthTokensInStorage),
      Effect.asUnit,
    );
  }

  export function authenticate({ email, password }: Auth.AuthenticateParams): OAuth.HttpEffect {
    return OAuthService.passwordStrategyRequest(email, password);
  }

  export function logout() {
    return OAuthService.removeOAuthTokensInStorage();
  }
}
